import React, { useEffect, useState } from 'react';
import useNewsStore from '../../store/newsStore';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase/config';
import Preloader from '../Preloader/Preloader';
import ReactPaginate from 'react-paginate';
import '../../assets/sass/Pagination.css'

const ProjectStyleTwoItem = ({ image, title, url, date, des }) => {
    return (
        <>
            <div className="col-lg-4 col-md-6 portfolio-item mt-30">
                <div style={{borderTop: '1px solid black', borderRight: '1px solid black', borderLeft: '1px solid black'}} className="portfolio__area-two-item"> 
                    <img className="img__full" src={image} alt="" />
					<div className="portfolio__area-two-item-content"> 
                        <span>{des}</span>
						<a target='_blank' style={{color: '#E3CC96'}} href={url}>read more</a> 
                    </div>
				</div>
                <div style={{border: '1px solid black', backgroundColor: 'black', padding: '8px'}}>
                    <p>{date ? `${new Date(date).getDate()}.${new Date(date).getMonth() + 1}.${new Date(date).getFullYear()} - ${new Date(date).getHours()}:${new Date(date).getMinutes()}` : ''}</p>
                    <h5 style={{marginTop: '10px'}}>{title}</h5>
                </div>
            </div>
        </>
    )
}

const PortfolioFilter = () => {

    const { news, setNews, isLoading, setLoading} = useNewsStore();

    const fetchData = async () => {
        setLoading(true);
        try {
            const querySnapshot = await getDocs(collection(db, 'news'));
            const data = querySnapshot.docs.map(doc => doc.data());
            setNews(data);
            localStorage.setItem('newsLastFetchTime', Date.now().toString()); 
            localStorage.setItem('news', JSON.stringify(data)); 
        } catch (error) {
            console.error('Ошибка при загрузке данных:', error);
        } finally {
            setLoading(false); 
        }
    };

    const shouldFetchData = () => {
        const lastFetchTime = localStorage.getItem('newsLastFetchTime');
        const currentTime = Date.now();
        const twelveHoursInMillis = 12 * 60 * 60 * 1000; 

        return !lastFetchTime || (currentTime - parseInt(lastFetchTime)) > twelveHoursInMillis;
    };

    useEffect(() => {
        const storedNews = localStorage.getItem('news');
        if (shouldFetchData()) {
            fetchData();
        } else if (storedNews) {
            setNews(JSON.parse(storedNews));
            setLoading(false)
        }
    }, []); 

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 9;

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        window.scrollTo(0, 0)
    };

    const offset = currentPage * itemsPerPage;
    const currentItems = news.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(news.length / itemsPerPage);


    return <>
        {
            isLoading ? <Preloader /> : <>
                <div className="portfolio__area-two section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 mb-30">
                                <div className="portfolio__area-two-title"> 
                                    <span className="subtitle-one">News</span>
                                    <h2>Latest PUBGM news</h2> 
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {currentItems.map((item, index) => (
                                <ProjectStyleTwoItem
                                key={index}
                                image={item.image}
                                title={item.title}
                                url={item.newsUrl}
                                des={item.description}
                                date={item.date ? new Date(item.date.seconds * 1000).toUTCString() : false}
                                />
                            ))}
                        </div>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'..'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={2}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination-tme'}
                            activeClassName={'active'}
                            disabledClassName={'disabled'}
                        />
                    </div>
                </div>
            </>
        }
    </>
};

export default PortfolioFilter;